module.exports = __webpack_public_path__ + "media/img/frontend_application/master_card-61db6a534945213f82729203a915ce00.svg";